export default [
  { columnName: 'id', width: 100 },
  {
    columnName: 'author_id',
    width: 150,
  },
  {
    columnName: 'agent_id',
    width: 150,
  },
  {
    columnName: 'surname',
    width: 200,
  },
  {
    columnName: 'name',
    width: 200,
  },
  {
    columnName: 'booking_account_id',
    width: 200,
  },
  {
    columnName: 'tax_id',
    width: 200,
  },
  { columnName: 'price', width: 200 },
  { columnName: 'description', width: 'auto' },
  {
    columnName: 'exported_at',
    width: 200,
  },
  {
    columnName: 'month',
    width: 200,
  },
  { columnName: 'year', width: 80 },
  {
    columnName: 'type',
    width: 200,
  },
];
